import React from 'react';
import Alert from '../ui/Alert';
import { thinFix } from './seoThin';

/* Page/listing editor banner: why it is thin and what fixes it. The verdict is
   the server's, as of the last save. */
export default function ThinBanner({ verdict, noun = 'page' }) {
  if (!verdict?.thin) return null;
  return (
    <Alert type="warning">
      <strong>This {noun} is thin, so search engines are told not to index it</strong> and it is left out of
      the sitemap. Visitors still see it. Fix these and save; it becomes indexable on the next render.
      <ul style={{ margin: '6px 0 0', paddingLeft: 20 }}>
        {(verdict.reasons || []).map((r) => {
          const fix = thinFix(r);
          return (
            <li key={r}>
              {r}{fix && <span className="muted"> — {fix}</span>}
            </li>
          );
        })}
      </ul>
    </Alert>
  );
}
